var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.974 140C123.868 140 139.976 123.868 139.976 103.998V56.0024C139.976 36.1317 123.868 20 103.974 20H56.0024C36.1317 20 20 36.1317 20 56.0024V103.998C20 123.868 36.1317 140 56.0024 140H103.974Z",
    fill: "#A08537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.421 136.755C121.045 136.755 136.142 121.564 136.142 102.869V57.625C136.142 38.9066 121.045 23.739 102.421 23.739H57.4121C38.7642 23.739 23.6672 38.9066 23.6672 57.625V102.869C23.6672 121.564 38.7878 136.755 57.4121 136.755H102.421Z",
    fill: "#2D2C71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8125 53.4391C59.8125 53.4391 51.7937 53.4156 51.8172 53.4391C66.2087 58.3539 76.485 70.535 79.8948 82.4103H35.9207V62.9865H45.7737V72.5573H63.0576C57.508 66.1611 45.7031 60.5879 35.9207 60.9406V43.6096H59.836V53.4391H59.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.972 53.4155C94.6155 58.0716 84.0335 68.8182 79.7772 82.3867H111.288V72.5337H96.6614C101.012 67.2662 109.548 62.7042 113.828 62.1398V82.3867H123.822V40.7642H113.828V43.5625H99.9065V53.4155H107.972Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7942 41.0463H88.9248V64.2092C92.1229 60.7289 95.4151 58.2833 98.6132 56.308V31.499H61.0823V56.308C64.6567 58.4714 67.9253 61.1051 70.7707 64.1622L70.7942 41.0463Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8953 88.0305H73.7319C74.8136 88.0305 74.8136 89.7237 73.7319 89.7237H35.8953V93.6272H70.6043C75.1428 93.6272 74.5785 97.766 74.5785 97.766V128.736H79.0229V90.241C79.0229 87.3721 77.3298 84.6443 74.5785 84.127H35.8953V88.0305Z",
    fill: "#A08537"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8953 99.2709H67.5473C68.629 99.2709 68.629 100.964 67.5473 100.964H35.8953V104.915H64.4197C68.9582 104.915 68.3939 109.053 68.3939 109.053V128.736H72.8148V100.635C72.8148 97.2251 73.3556 95.3203 68.9112 95.3203H35.8953V99.2709Z",
    fill: "#A08537"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8953 110.512H61.3157C62.4444 110.512 62.4914 112.205 61.3157 112.205H35.8953V116.155H58.2586C62.7971 116.155 62.2328 120.294 62.2328 120.294V128.736H66.6537V111.875C66.6537 108.466 67.1946 106.584 62.7501 106.584H35.8953V110.512Z",
    fill: "#A08537"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.798 84.127H85.1388C82.411 84.6678 80.7178 87.3721 80.7178 90.241V128.736H85.1388V97.766C85.1388 97.766 84.5979 93.6272 89.1129 93.6272H123.822V89.7237H85.9853C84.9036 89.7237 84.9036 88.0305 85.9853 88.0305H123.822V84.127H123.798Z",
    fill: "#A08537"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.798 95.344H90.7823C86.3614 95.344 86.8787 97.2252 86.8787 100.659V128.76H91.2996V109.077C91.2996 109.077 90.7353 104.938 95.2738 104.938H123.798V100.988H92.1697C91.088 100.988 91.088 99.2946 92.1697 99.2946H123.822V95.344H123.798Z",
    fill: "#A08537"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.798 106.584H96.9431C92.4987 106.584 93.0395 108.466 93.0395 111.875V128.736H97.4605V120.294C97.4605 120.294 96.8961 116.155 101.435 116.155H123.798V112.205H98.4011C97.2253 112.205 97.2723 110.512 98.4011 110.512H123.821V106.584H123.798Z",
    fill: "#A08537"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.976,
    height: 120,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaac);
export default __webpack_public_path__ + "static/media/baac.8548721a.svg";
export { ForwardRef as ReactComponent };